import { ReactNode } from 'react'
import { CheckCircle2, Loader2 } from 'lucide-react'

interface LoadingItem {
    id: string
    label: string
}

interface OnboardingLoadingProps {
    logoSrc: string
    illustrations: ReactNode[]
    loadingItems: LoadingItem[]
    completedLoadingSteps: number
    activeLoadingIndex: number
    currentIllustrationStage: number
}

export const OnboardingLoading = ({
    logoSrc,
    illustrations,
    loadingItems,
    completedLoadingSteps,
    activeLoadingIndex,
    currentIllustrationStage,
}: OnboardingLoadingProps) => {
    return (
        <div className='flex flex-col items-center gap-10 px-10 text-center py-14'>
            <img src={logoSrc} alt='CommZone logo' className='w-auto h-14' />
            <div className='relative w-48 h-48'>
                {illustrations.map((illustration, index) => (
                    <div
                        key={index}
                        className={`absolute inset-0 flex items-center justify-center transition-all duration-700 ${
                            currentIllustrationStage === index
                                ? 'translate-y-0 opacity-100'
                                : 'pointer-events-none translate-y-3 opacity-0'
                        }`}
                    >
                        {illustration}
                    </div>
                ))}
            </div>

            <ul className='flex flex-col w-full max-w-sm gap-4 text-left'>
                {loadingItems.map((item, idx) => {
                    const isCompleted = idx < completedLoadingSteps
                    const isActive = idx === activeLoadingIndex && completedLoadingSteps <= loadingItems.length
                    return (
                        <li key={item.id} className='flex items-center gap-3 text-sm font-medium'>
                            {isCompleted ? (
                                <CheckCircle2 className='h-5 w-5 text-orange-base' />
                            ) : isActive ? (
                                <Loader2 className='h-5 w-5 animate-spin text-orange-base' />
                            ) : (
                                <Loader2 className='h-5 w-5 text-violet-mist' />
                            )}
                            <span
                                className={`transition-colors ${
                                    isCompleted
                                        ? 'text-orange-base'
                                        : isActive
                                          ? 'text-violet-medium'
                                          : 'text-violet-haze'
                                }`}
                            >
                                {item.label}
                            </span>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}
